import React, { useState, useMemo ,useEffect} from 'react';
import { useAuth } from '../hooks/useAuth';

// --- Initial Demo Data ---
const initialCategories = [
    { id: 1, name: "Medications" },
    { id: 2, name: "Follow-Up Care" },
    { id: 3, name: "Home & Support" },
    
    { id: 4, name: "Symptoms Check" },
    { id: 5, name: "Daily Activities" },
];

const initialQuestions = [
    { id: 101, categoryId: 1, name: "Medications", text: "Do you know which medications you need to take at home?" },
    { id: 102, categoryId: 1, name: "Medications", text: "Do you understand the purpose, dosage, and timing of each medication?" },
    { id: 103, categoryId: 1, name: "Medications", text: "Do you have any questions about side effects or interactions?" },
    { id: 104, categoryId: 2, name: "Follow-Up Care" , text: "Do you know when and where your follow-up appointments are?" },
    { id: 105, categoryId: 2, name: "Follow-Up Care" , text: "Do you need help scheduling any follow-up visits?" },
    { id: 106, categoryId: 2, name: "Follow-Up Care" , text: "Are you aware of any tests or procedures you need after discharge?" },
    { id: 107, categoryId: 3, name: "Home & Support" , text: "Do you have someone to help you at home if needed?" },
    { id: 108, categoryId: 3, name: "Home & Support" ,text: "Do you have any mobility issues or need home equipment (walker, oxygen, etc.)?" },
    { id: 109, categoryId: 4, name: "Symptoms Check" ,text: "Are you experiencing shortness of breath, chest pain, dizziness, or swelling?" },
    { id: 110, categoryId: 4, name: "Symptoms Check" ,text: "Do you have fever, cough, or signs of infection?" },
    { id: 111, categoryId: 5, name: "Daily Activities" ,text: "Are you able to eat, drink, and move around as expected?" },
    { id: 112, categoryId: 5, name: "Daily Activities" ,text: "Are you able to care for yourself at home (walking, bathing, etc.)?" },
    


];


// --- Helper Components ---
const Spinner = () => (
    <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>
);

const TrashIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gray-400 hover:text-red-500 transition-colors">
        <path d="M3 6h18" /><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" /><line x1="10" x2="10" y1="11" y2="17" /><line x1="14" x2="14" y1="11" y2="17" />
    </svg>
);


// --- Main App Component ---
export default function CallCase( { onSelectedItemsChange }) {
    const API_URL = process.env.NODE_ENV === 'development' ? "https://demo.aiguardian.io/agent-backend": "/agent-backend";
    // --- State Management ---
    const [items, setItems] = useState([]);
    const [questions, setQuestions] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [selectedQuestions, setSelectedQuestions] = useState([]);
    
    const [newQuestionText, setNewQuestionText] = useState('');
    const [categorySearchTerm, setCategorySearchTerm] = useState('');

    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { user, logout } = useAuth();
    
    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            setError(null);
            try {
                const [categoriesRes, questionsRes] = await Promise.all([
                    fetch(`${API_URL}/api/categories`, {
                        headers: { 'Authorization': `Bearer ${user.token}` }
                    }),
                    fetch(`${API_URL}/api/questions`, {
                        headers: { 'Authorization': `Bearer ${user.token}` }
                    })
                ]);

                if (!categoriesRes.ok || !questionsRes.ok) {
                    throw new Error('Failed to fetch data');
                }

                const categoriesData = await categoriesRes.json();
                const questionsData = await questionsRes.json();

                setItems(categoriesData.categories);
                setQuestions(questionsData.questions);
            } catch (err) {
                setError(err.message);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [user.token, API_URL]);

    // --- Handlers ---
    // const handleCategorySelect2 = (item) => {
    //     setSelectedItems(prevSelected => {
    //         const isSelected = prevSelected.some(i => i.id === item.id);
    //         if (isSelected) {
    //             return prevSelected.filter(i => i.id !== item.id);
    //         } else {
    //             return [...prevSelected, item];
    //         }
    //     });
    // };

        const handleCategorySelect = ( item) => {
        //const isCtrlPressed = event.ctrlKey || event.metaKey; // metaKey for macOS
        //const isAlreadySelected = selectedItems.some(item => item.id === clickedItem.id);

        //if (isCtrlPressed) {
            setSelectedItems(prevSelected => {
            const isSelected = prevSelected.some(i => i.id === item.id);
            if (isSelected) {
                return prevSelected.filter(i => i.id !== item.id);
            } else {
                return [...prevSelected, item];
            }
        });
        //} else {
            // if (isAlreadySelected && selectedItems.length === 1) {
            //     setSelectedItems([]);
            // } else {
            //     setSelectedItems([item]);
            // }
        //    setSelectedItems([item]);

            // setSelectedQuestions(prevSelected => {
            //     return prevSelected.filter(q => item.id == q.categoryId);
            // })
       // }

    };

    useEffect(() => {
        const ids = selectedItems.map(item => item.id);
        const filtered = selectedQuestions.filter(item => ids.includes(item.categoryId));
        setSelectedQuestions(filtered);
      }, [selectedItems]);


    const handleQuestionSelect = (question) => {
        setSelectedQuestions(prevSelected => {
            const isSelected = prevSelected.some(q => q.id === question.id);
            if (isSelected) {
                return prevSelected.filter(q => q.id !== question.id);
            } else {
                return [...prevSelected, question];
            }
        });
    };

    const handleQuestionSelectAll = (question) => {
        console.log(question)

        setSelectedQuestions(prevSelected => {
            // Check if ALL questions in the list are selected
            const allSelected = question.every(q => 
              prevSelected.some(selected => selected.id === q.id)
            );
            
            if (allSelected) {
              // Remove all questions from the list
              return prevSelected.filter(selected => 
                !question.some(q => q.id === selected.id)
              );
            } else {
              // Add all questions that aren't already selected
              const questionsToAdd = question.filter(q => 
                !prevSelected.some(selected => selected.id === q.id)
              );
              return [...prevSelected, ...questionsToAdd];
            }
          });
          
        // setSelectedQuestions(prevSelected => {            
        //         return [...prevSelected, ...question];
            
        // });
        // setSelectedQuestions(prevSelected => {
        //     const isSelected = prevSelected.some(q => q.id === question.id);
        //     if (isSelected) {
        //         return prevSelected.filter(q => q.id !== question.id);
        //     } else {
        //         return [...prevSelected, question];
        //     }
        // });
    };

    const handleAddItem = async (e) => {
        e.preventDefault();
        const trimmedTerm = categorySearchTerm.trim();
        const exactMatchFound = items.some(item => item.name.toLowerCase() === trimmedTerm.toLowerCase());
        
        if (trimmedTerm === '' || exactMatchFound) return;

        setIsSubmitting(true);
        try {
            const response = await fetch(`${API_URL}/api/categories`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user.token}`
                },
                body: JSON.stringify({ name: trimmedTerm })
            });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const newItem = await response.json();
            setItems(prev => [...prev, newItem.category]);
            setCategorySearchTerm('');
        } catch (error) {
            console.error("Failed to add item:", error);
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleAddQuestion = async (e) => {
        e.preventDefault();
        if (!newQuestionText.trim() || selectedItems.length !== 1) return;
        
        setIsSubmitting(true);
        const selectedItem = selectedItems[0];
        
        const newQuestionPayload = {
            categoryId: selectedItem.id,
            name: selectedItem.name,
            text: newQuestionText.trim()
        };

        try {
            const response = await fetch(`${API_URL}/api/questions`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${user.token}` },
                body: JSON.stringify(newQuestionPayload)
            });
            if (!response.ok) throw new Error('Failed to add question');
            const newQuestion = await response.json();
            setQuestions(prev => [...prev, newQuestion.question]);
            setNewQuestionText('');
        } catch (error) {
            console.error("Failed to add question:", error);
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleDeleteItem = async (e, itemId) => {
        e.stopPropagation();
        const itemToDelete = items.find(item => item.id === itemId);
        if (!window.confirm(`Are you sure you want to delete "${itemToDelete?.name}" and all its questions?`)) return;

        try {
            const response = await fetch(`${API_URL}/api/categories/${itemId}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${user.token}`
                }
            });

            if (!response.ok) throw new Error('Failed to delete item');

            setItems(prev => prev.filter(item => item.id !== itemId));
            setQuestions(prev => prev.filter(q => q.categoryId !== itemId));
            setSelectedItems(prev => prev.filter(i => i.id !== itemId));
            setSelectedQuestions(prev => prev.filter(q => q.categoryId !== itemId));
        } catch (error) {
            console.error("Failed to delete item:", error);
        }
    };

    const handleDeleteQuestion = async (e, questionToDelete) => {
        e.stopPropagation();
        if (!window.confirm(`Are you sure you want to delete the question?`)) return;

        try {
            const response = await fetch(`${API_URL}/api/questions/${questionToDelete.id}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${user.token}`
                }
            });

            if (!response.ok) throw new Error('Failed to delete question');

            setQuestions(prev => prev.filter(q => q.id !== questionToDelete.id));
            setSelectedQuestions(prev => prev.filter(q => q.id !== questionToDelete.id));
        } catch (error) {
            console.error("Failed to delete question:", error);
        }
    };
    
    // --- Computed State for UI Logic ---
    const filteredItems = items.filter(item =>
        item.name.toLowerCase().includes(categorySearchTerm.toLowerCase())
    );

    const canAddNew = useMemo(() => {
        const trimmedTerm = categorySearchTerm.trim();
        if (trimmedTerm === '') return false;
        return !items.some(item => item.name.toLowerCase() === trimmedTerm.toLowerCase());
    }, [categorySearchTerm, items]);


    useEffect(() => {
        onSelectedItemsChange(selectedQuestions);
      }, [selectedQuestions, onSelectedItemsChange]);

    // --- UI Rendering ---
    if (isLoading) {
        return <div className="text-center p-8">Loading questions...</div>;
    }

    if (error) {
        return <div className="text-center p-8 text-red-600">Error: {error}</div>;
    }

    return (
        <div className="bg-slate-50  font-sans text-slate-800">
            <div >              

                
                    {/* Column 1: Categories (Items) */}
                    <div className="mb-4 bg-white p-6 rounded-xl  border border-slate-200 flex flex-col">
                        <h2 className="text-2xl font-semibold mb-4">Call Case</h2> 
                        <form onSubmit={handleAddItem} className="flex gap-2 mb-4">
                            <input
                                type="text"
                                value={categorySearchTerm}
                                onChange={(e) => setCategorySearchTerm(e.target.value)}
                                placeholder="Search or add new case..."
                                className="flex-grow p-2 border border-slate-300 rounded-md focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition"
                            />
                            {canAddNew && (
                                <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition flex-shrink-0 flex items-center justify-center disabled:bg-blue-300" disabled={isSubmitting}>
                                    {isSubmitting ? <Spinner /> : 'Add'}
                                </button>
                            )}
                        </form>
                        
                        <div  className="space-y-3">
                            {filteredItems.length > 0 ? filteredItems.map(item => (
                                <div key={item.id} className="flex justify-between items-center bg-slate-100 p-2 rounded-lg hover:bg-slate-200 transition-colors">
                                    <label className="flex items-center gap-3 cursor-pointer flex-grow p-1">
                                        <input 
                                            type="checkbox" 
                                            
                                            checked={selectedItems.some(i => i.id === item.id)} 
                                            onChange={() => handleCategorySelect(item)} 
                                            className="h-5 w-5 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                        />
                                        <span className="font-medium text-slate-800">{item.name}</span>
                                    </label>
                                    <button onClick={(e) => handleDeleteItem(e, item.id)} className="p-2 rounded-full hover:bg-slate-300"><TrashIcon /></button>
                                </div>
                            )) : (
                                <p className="text-slate-500 p-4 text-center bg-slate-50 rounded-md">No categories match your search.</p>
                            )}
                        </div>
                    </div>

                    {/* Column 2: Questions */}
                    <div className=" bg-white p-6 rounded-xl border border-slate-200">
                        {selectedItems.length > 0 ? (
                            <>
                                <div className="mb-6 p-4 bg-slate-50 rounded-lg border border-slate-200">
                                    <h3 className="font-semibold text-lg mb-2">Add New Question</h3>
                                    {selectedItems.length === 1 ? (
                                        <form onSubmit={handleAddQuestion} className="flex gap-2">
                                            <input type="text" value={newQuestionText} onChange={(e) => setNewQuestionText(e.target.value)} placeholder={`Add to "${selectedItems[0].name}"...`} className="flex-grow p-2 border border-slate-300 rounded-md focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition" disabled={isSubmitting}/>
                                            <button type="submit" className="bg-emerald-600 text-white px-4 py-2 rounded-md hover:bg-emerald-700 transition flex items-center justify-center disabled:bg-emerald-300" disabled={!newQuestionText.trim() || isSubmitting}>
                                                {isSubmitting && newQuestionText ? <Spinner /> : 'Add'}
                                            </button>
                                        </form>
                                    ) : (
                                        <p className="text-slate-500 text-sm">Please select exactly one call case to add a new question.</p>
                                    )}
                                </div>

                                <div className="flex justify-between items-center mb-4">
                                    <h2 className="text-2xl font-semibold">Selected Questions</h2> <span>(maximum number of questions per call is 10) </span>
                                    <span className="text-sm font-medium text-slate-500 bg-slate-100 px-3 py-1 rounded-full">{selectedQuestions.length} selected</span>
                                </div>

                                <div className="">
                                    {selectedItems.map(item => {
                                        const categoryQuestions = questions
                                            .filter(q => q.categoryId === item.id)
                                            .sort((a, b) => a.text.localeCompare(b.text));
                                        
                                        if (categoryQuestions.length === 0) return (
                                            <div key={item.id}>
                                                 <h3 className="text-lg font-semibold text-blue-600 border-b-2 border-blue-200 pb-1 mb-3">{item.name}</h3>
                                                 <p className="text-slate-500 text-sm pl-2">No questions in this category.</p>
                                            </div>
                                        );

                                        return (
                                            <div key={item.id}>
                                                <h3 className="text-lg font-semibold text-blue-600 border-b-2 border-blue-200 pb-1 mb-3">{item.name}</h3>
                                                
                                                <div onClick={ () => handleQuestionSelectAll(categoryQuestions) } className="flex justify-between items-center  p-3 rounded-lg border border-slate-200">
                                                
                                                <label className="flex items-center gap-3 cursor-pointer flex-grow">                                                                
                                                                <svg xmlns="http://www.w3.org/2000/svg"   width="32" height="32" className="bi bi-check-all" viewBox="0 0 16 16">
  <path d="M8.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L2.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093L8.95 4.992zm-.92 5.14.92.92a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 1 0-1.091-1.028L9.477 9.417l-.485-.486z"/>
</svg>

                                                                <p className="flex-grow">Select / Deselect All</p>
                                                            </label>
                                                </div>            
                                                            
                                                <div className="space-y-3">
                                                    {categoryQuestions.map(q => (
                                                        <div key={q.id} className="flex justify-between items-center bg-slate-50 p-3 rounded-lg border border-slate-200">
                                                            <label className="flex items-center gap-3 cursor-pointer flex-grow">
                                                                <input 
                                                                    type="checkbox" 
                                                                    checked={selectedQuestions.some(sq => sq.id === q.id)} 
                                                                    onChange={() => handleQuestionSelect(q)}
                                                                    className="h-5 w-5 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                                                />
                                                                <p className="flex-grow">{q.text}</p>
                                                            </label>
                                                            <button onClick={(e) => handleDeleteQuestion(e, q)} className="p-1 rounded-full opacity-60 hover:opacity-100 flex-shrink-0 ml-2"><TrashIcon /></button>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </>
                        ) : (
                            <div className="flex items-center justify-center h-full">
                                <p className="text-slate-500 text-lg text-center">Select one or more call case to begin.</p>
                            </div>
                        )}
                    </div>
                
                
                
            </div>
        </div>
    );
}